import { render, staticRenderFns } from "./FaqDetails.vue?vue&type=template&id=6bdd0140&scoped=true&"
import script from "./FaqDetails.vue?vue&type=script&lang=js&"
export * from "./FaqDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bdd0140",
  null
  
)

export default component.exports